import React from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { OpenedElsewherePromptProps } from './types';
import MessageDialog from '10.quickConnect.app/components/shared/Dialogs/MessageDialog';

const openedElsewherePromptName = 'openedElsewherePromptComponent';

/**
 * Popups d'une saisie ouverte dans un autre onglet : consultation en lecture seule de la saisie, ou nouvelle saisie du
 * formulaire. Fermer la popup refuse la proposition.
 */
const OpenedElsewherePrompt = ({ prompt, confirm, refuse }: OpenedElsewherePromptProps) => {
  const { t } = useTranslation('forms');
  if (!prompt) return null;

  const { kind, name, isInbox } = prompt;

  return kind === 'entry' ? (
    <MessageDialog
      name={`${openedElsewherePromptName}-entry`}
      open
      onClose={refuse}
      title={t('qcapp_opened_elsewhere_title').toString()}
      message={t(isInbox ? 'qcapp_opened_elsewhere_inbox' : 'qcapp_opened_elsewhere_form', { name }).toString()}
      options={[
        {
          name: 'open-read-only',
          label: t('qcapp_opened_elsewhere_open_read_only').toString(),
          icon: <VisibilityIcon />,
          onClick: confirm,
        },
      ]}
      closeLabel={t('qcapp_opened_elsewhere_back_to_list').toString()}
    />
  ) : (
    <MessageDialog
      name={`${openedElsewherePromptName}-form`}
      open
      onClose={refuse}
      title={t('qcapp_opened_elsewhere_title').toString()}
      message={t('qcapp_opened_elsewhere_form', { name }).toString()}
      options={[
        {
          name: 'dialog-option-create-dcl',
          label: t('qcapp_new_form_type_info').toString(),
          icon: <AddIcon />,
          onClick: confirm,
        },
      ]}
      closeLabel={t('qcapp_dialog_item_data_close').toString()}
    />
  );
};

export default OpenedElsewherePrompt;
